module.exports = __webpack_public_path__ + "static/img/6.8af859e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/sp/6.png
// module id = gJY6
// module chunks = 0